var map = {
	"./de.json": 762778,
	"./en.json": 260681,
	"./es.json": 805510,
	"./fr.json": 166210,
	"./it.json": 197626,
	"./ja.json": 11850,
	"./ko.json": 427609,
	"./pl.json": 284931,
	"./pt.json": 975078,
	"./ru.json": 571950,
	"./uk.json": 749269
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 821120;